export const DEFAULT_SETTINGS_SECTION_ID = 'users'
